export default "__VITE_ASSET__C5_vL_pk__"